import { render, staticRenderFns } from "./EMelderComponentEinstellungenAuswahllisten.vue?vue&type=template&id=1d64b7b4&scoped=true"
import script from "./EMelderComponentEinstellungenAuswahllisten.vue?vue&type=script&lang=js"
export * from "./EMelderComponentEinstellungenAuswahllisten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d64b7b4",
  null
  
)

export default component.exports